import { Tooltip } from '@mui/material'
import isEmpty from 'lodash/isEmpty'

export const setParentData = (data, parent) => {
  if (parent) {
    if (parent.parent) {
      return {
        ...parent,
        parent: setParentData(data, parent.parent)
      }
    } else {
      return {
        ...parent,
        parent: data
      }
    }
  } else {
    return data
  }
}

export const setChildrenForm = (form, parent, data) => {
  if (parent) {
    if (form[parent._id]) {
      return {
        ...form,
        [parent._id]: {
          ...(form[parent._id] || {}),
          value: form[parent._id].value,
          children: setChildrenForm(form[parent._id].children, parent.parent, data)
        }
      }
    } else {
      return {
        ...form,
        [parent._id]: {
          ...(form[parent._id] || {}),
          value: form[parent._id].value,
          children: setChildrenForm({}, parent.parent, data)
        }
      }
    }
  } else {
    return {
      ...form,
      ...data
    }
  }
}
const baseFormDataCurrcilumElement = (value) => {
  const formData = {
    value: value.value,
    children: {}
  }
  if (value.find) {
    if (Array.isArray(value.find)) {
      formData.find = value.find.map((item) => {
        return {
          _id: item._id,
          name: item.name
        }
      })
    } else {
      formData.find = {
        _id: value.find._id,
        name: value.find.name
      }
    }
  }
  if (value.name) {
    formData.name = value.name
  }
  return formData
}
export const setChildrenData = (form, name, value) => {
  if (form[name]) {
    return {
      ...form,
      [name]: baseFormDataCurrcilumElement(value)
    }
  } else {
    if (value.parent) {
      return setChildrenForm(form, value.parent, {
        [name]: baseFormDataCurrcilumElement(value)
      })
    } else {
      return {
        ...form,
        [name]: baseFormDataCurrcilumElement(value)
      }
    }
  }
}

export const validateCurriculumElements = (formData, current) => {
  if (isEmpty(formData)) {
    return {
      message: 'Elements are required.'
    }
  } else {
    const mapCheck = (elements, structures, form) => {
      let message = ''

      structures.forEach((structure) => {
        const element = elements.find((el) => el.elementStructureId === structure._id) || { children: [] }

        if (structure.mandatory && element.children.length > 0) {
          const newForm = form[structure._id]

          if (newForm) {
            if (!newForm.value) {
              message = `${structure.name} is required.`
            } else {
              const newElements = element.children.find((el) => String(el._id) === String(newForm.value))

              message = mapCheck(newElements.elements || [], structure.children, newForm.children)
            }
          } else {
            message = `${structure.name} is required.`
          }
        }
      })

      return message
    }
    const structure = current.elementsStructure
    const elements = current.elements

    const message = mapCheck([elements], [structure], formData)
    if (message) {
      return {
        message
      }
    }
  }

  return {}
}
export const validateLcElements = (formData, elements) => {
  if (isEmpty(formData)) {
    return {
      message: 'Elements are required.'
    }
  } else {
    let errors = {}
    elements.forEach((element) => {
      if (isEmpty(formData[element._id])) {
        errors = {
          message: `${element.name} is required.`
        }
      }
    })

    return errors
  }
}
export const validateLevels = (formData, elements) => {
  if (isEmpty(formData)) {
    return {
      message: 'Levels are required.'
    }
  } else {
    const checkLevels = Object.keys(formData).filter((key) => !isEmpty(formData[key]))

    if (checkLevels.length === 0) {
      return {
        message: 'Levels are required.'
      }
    }
    const find = elements.find((el) => el.position === 0)
    if (find && isEmpty(formData[find._id])) {
      return {
        message: `${find.name} is required.`
      }
    }

    let count = 0

    const group = {}
    let fff = false
    const levels = elements
      .sort((a, b) => a.position - b.position)
      .map((el) => {
        return {
          levelId: el._id,
          definition: formData[el._id] || '',
          name: el.name
        }
      })
    for (let i = 1; i < levels.length - 1; i++) {
      if (levels[i].definition) {
        if (group[count]) {
          group[count].push(levels[i].levelId)
        } else {
          group[count] = [levels[i].levelId]
        }
      } else {
        if (group[count]?.length > 0) {
          if (!fff) {
            fff = true
          }
        }
        count++
      }
    }

    if (Object.keys(group).length > 1) {
      return { message: 'Each level must contain a descriptor before the continuum can be saved.' }
    }
  }

  return {}
}

export const getFilterCurriculumElementsDR = (curriculumElements = {}, currentCurriculum = {}) => {
  const filter = {}
  const { element, subElement } = getObjectCurriculumElementsDR(
    currentCurriculum?.elements,
    currentCurriculum?.elementsStructure,
    curriculumElements
  )
  if (curriculumElements.elementId) {
    const newValue = Array.isArray(curriculumElements.elementId.value)
      ? curriculumElements.elementId.value
      : [curriculumElements.elementId.value]
    filter[curriculumElements.elementId.key] = {
      value: newValue
    }
    if (element) {
      filter[curriculumElements.elementId.key].name = element.keyName
      filter[curriculumElements.elementId.key].find = [
        {
          name: element.valueName,
          _id: element.value
        }
      ]
    }
    if (curriculumElements.subElementId) {
      const subElementf = {}
      const newValue2 = Array.isArray(curriculumElements.subElementId.value)
        ? curriculumElements.subElementId.value
        : [curriculumElements.subElementId.value]
      subElementf[curriculumElements.subElementId.key] = {
        value: newValue2
      }
      if (subElement) {
        subElementf[curriculumElements.subElementId.key].name = subElement.keyName
        subElementf[curriculumElements.subElementId.key].find = [
          {
            name: subElement.valueName,
            _id: subElement.value
          }
        ]
      }

      filter[curriculumElements.elementId.key].children = subElementf
    }
  }

  return { curriculumElements: filter }
}

export const getObjectCurriculumElementsDR = (curriculumElements = {}, structure = {}, form = {}) => {
  const element = {
    key: form?.elementId?.key,
    value: form?.elementId?.value,
    keyName: structure?.name,
    valueName: curriculumElements?.children?.find((item) => item._id === form?.elementId?.value)?.name
  }

  if (form.subElementId) {
    const elementChildren = curriculumElements?.children?.find((item) => item._id === form.elementId?.value)
    const subElementObj = elementChildren?.elements[0]

    const subElement = {
      key: form.subElementId.key,
      value: form.subElementId.value,
      keyName: structure?.children ? structure?.children[0].name : '',
      valueName: subElementObj?.children?.find((item) => item._id === form?.subElementId?.value)?.name
    }
    return { element, subElement }
  }

  return { element }
}

export const columnsLearningContinuum = (currentCurriculum, list = []) => {
  const columns = [
    {
      label: 'Version',
      key: 'version',
      align: 'center',
      className: 'text-center',
      show: true,
      width: 50,
      hide: true,
      position: 0
    }
  ]

  if (currentCurriculum) {
    const elements = {}
    let positionCounter = 1

    // Sort lcElements descending by position so the highest-position element (Key Skills)
    // comes first and is placed right after Version, before Learning Area.
    // Remaining lcElements (e.g. Organising Elements) go after curriculum structure elements.
    const sortedLcElements = [...(currentCurriculum?.lcElements?.children || [])].sort(
      (a, b) => b.position - a.position
    )

    // The lcElement with the highest position (Key Skills) goes right after Version
    if (sortedLcElements.length > 0) {
      const firstLc = sortedLcElements[0]
      elements[firstLc._id] = {
        label: firstLc.name,
        key: firstLc._id,
        show: true,
        // Los lcElements (Key Skills, Organising Elements) son data personalizada de
        // la escuela, NO parte de la estructura del curriculum. No deben mostrar el
        // hover con la referencia al curriculum (caret → <TextCurriculum>). MF-447.
        caret: false,
        hide: true,
        position: positionCounter++,
        width: 100,
        className: 'text-nowrap',
        type: 'lcElement',
        sort: true,
        sortKey: `_sort_${firstLc._id}`
      }
    }

    // Curriculum elements (Learning Area, Study Design, Unit, etc.)
    if (currentCurriculum.elementsStructure) {
      elements[currentCurriculum.elementsStructure?._id] = {
        label: currentCurriculum.elementsStructure?.name,
        key: currentCurriculum.elementsStructure?._id,
        show: true,
        caret: true,
        hide: true,
        position: positionCounter++,
        width: 100,
        type: 'structure',
        className: 'text-nowrap'
      }

      const mapElements = (child) => {
        elements[child._id] = {
          label: child.name,
          key: child._id,
          show: true,
          caret: true,
          hide: true,
          position: positionCounter++,
          width: 100,
          className: 'text-nowrap',
          type: 'structure'
        }
        child?.children?.forEach((element) => {
          mapElements(element)
        })
      }

      currentCurriculum.elementsStructure?.children.forEach((child) => {
        mapElements(child)
      })
    }

    // Remaining lcElements (e.g. Organising Elements) go after curriculum structure
    sortedLcElements.slice(1).forEach((element) => {
      elements[element._id] = {
        label: element.name,
        key: element._id,
        show: true,
        // lcElement = data personalizada de la escuela, no del curriculum → sin
        // hover de referencia al curriculum. MF-447.
        caret: false,
        hide: true,
        position: positionCounter++,
        width: 100,
        className: 'text-nowrap',
        type: 'lcElement',
        sort: true,
        sortKey: `_sort_${element._id}`
      }
    })

    Object.keys(elements).forEach((key) => {
      columns.push(elements[key])
    })
  }

  columns.sort((a, b) => a.position - b.position)

  return columns
}

export const getLastIdGranularStep = (granularSteps) => {
  const last = granularSteps
    .map((step) => {
      const position = parseInt(step.id.split('gs-')[1])
      return {
        ...step,
        position
      }
    })
    .sort((a, b) => b.position - a.position)[0]
  if (last) {
    const position = parseInt(last.id.split('gs-')[1])

    return String(position + 1)
  }
  return '1'
}

export const onFindCode = (assessmentData, assessmentAreas = []) => {
  const assessmentAreaId = String(assessmentData?._id)
  const elementId = String(assessmentData?.elementId)
  const subElementId = String(assessmentData?.subElementId)

  const codes =
    assessmentAreas?.filter(
      (area) =>
        String(area?.assessmentData?._id) === String(assessmentAreaId) &&
        String(area?.assessmentData?.elementId) === String(elementId) &&
        String(area?.assessmentData?.subElementId) === String(subElementId)
    ) || []

  return codes
}
